<template>
    <div class="explanation-container">
        <div>
            <h3 class="text-h5 text-left mb-3">{{ customer_data.first_name }} tapped the link!</h3>

            <p class="primary-note align-center mt-4">
                <v-icon size="24" color="primary" class="pb-1 mr-2">
                    mdi-robot
                </v-icon>
                <span>
                    The experience you're viewing here is all automatic - there's no human involved on the company's end unless the user opts to involve one.
                </span>
            </p>

            <div class="explanation-points">
                <div
                    class="explanation-point"
                    v-for="(point, idx) in explanationPoints"
                    :key="idx"
                >
                    <v-icon
                        color="primary"
                        size="28"
                        class="point-icon"
                        aria-hidden="true"
                    >
                        mdi-chevron-right
                    </v-icon>
                    <p class="point-text" v-html="point"></p>
                </div>
            </div>

            <div class="button-group">
                <v-btn color="primary" outlined @click="$emit('reset-web-experience')">
                    <v-icon 
                        left
                        size="20"
                    >
                        mdi-restart
                    </v-icon>
                    Restart Web Experience
                </v-btn>
                <v-btn color="primary" elevation="0" @click="$emit('reset')">
                    <v-icon 
                        left
                        size="20"
                    >
                        mdi-restart
                    </v-icon>
                    Restart Demo
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExplainerLandingPage',

    props: {
        customer_data: {
            type: Object,
            required: true
        },
        wine_data: {
            type: Object,
            required: true
        }
    },

    computed: {
        savings() {
            return (this.wine_data.regular_price - this.wine_data.club_price).toFixed(2);
        },

        explanationPoints() {
            return [
                `She's taken to Barrel Creek's website — outside SMS, the landing page <em>can</em> promote alcohol directly`,
                `An embedded chat lets her complete the entire purchase without leaving the page or switching back to SMS`,
                `If at any point a human needs to enter the loop, she can opt to leave the page and have an SMS alert sent when they're ready to continue the chat`,
                `Identity verification, payment, receipt delivery, and RedChirp app promotion are all woven into the conversational flow`,
            ];
        }
    }
}
</script>

<style lang="scss" scoped>
.explanation-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2rem;
    align-items: center;
    padding: 2rem;

    @media (max-width: 900px) {
        padding: .5rem 0;
    }

    .button-group {
        margin-top: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
    }
}
</style>
